import { useEffect, useState } from "react";
import { secondAxios } from "../../api/axios";

/**
 * Fetches a SharePoint/Graph file's bytes through the backend proxy
 * (GET /sharepoint/file?url=...) as a blob and exposes an object URL suitable
 * for an <iframe>. The backend re-fetches server-side, bypassing SharePoint's
 * X-Frame-Options / login-frame restrictions. Pass `url=null` to disable.
 */
const useSharePointPdf = (url) => {
  const [state, setState] = useState({
    blobUrl: null,
    loading: false,
    error: null,
  });

  useEffect(() => {
    if (!url) {
      setState({ blobUrl: null, loading: false, error: null });
      return undefined;
    }

    let revoked = false;
    let objectUrl = null;

    setState({ blobUrl: null, loading: true, error: null });

    secondAxios
      .get("/sharepoint/file", {
        params: { url },
        responseType: "blob",
      })
      .then((res) => {
        objectUrl = URL.createObjectURL(res.data);
        if (!revoked)
          setState({ blobUrl: objectUrl, loading: false, error: null });
      })
      .catch((err) => {
        if (!revoked) setState({ blobUrl: null, loading: false, error: err });
      });

    return () => {
      revoked = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  return state;
};

export default useSharePointPdf;
